import * as React from 'react';
import { SvgWrapper } from '../utils';
import type { IconProps } from '../utils';

const svg = (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em">
    <path
      fill="fj-icons-primary-color"
      d="M21.56 19.38a1.5 1.5 0 01.44 1.08A1.55 1.55 0 0120.46 22a1.41 1.41 0 01-1.08-.46l-4.12-4.11a8.22 8.22 0 01-4.8 1.49 8.36 8.36 0 01-3.28-.66 8.53 8.53 0 01-2.71-1.81 8.58 8.58 0 01-2.47-6 8.24 8.24 0 01.67-3.29 8.25 8.25 0 014.51-4.5 8.39 8.39 0 016.57 0 8.3 8.3 0 012.7 1.8 8.6 8.6 0 011.81 2.7 8.41 8.41 0 01.66 3.29 8.22 8.22 0 01-1.49 4.8l4.13 4.12zm-7.29-5.12a5.19 5.19 0 001.58-3.8 5.19 5.19 0 00-1.58-3.8 5.19 5.19 0 00-3.81-1.58 5.15 5.15 0 00-3.8 1.58 5.15 5.15 0 00-1.58 3.8 5.15 5.15 0 001.58 3.8 5.16 5.16 0 003.8 1.59 5.2 5.2 0 003.81-1.59z"
    />
  </svg>
);

const Search = ({
  style = {
    primaryColor: 'currentColor',
    bgColor: 'transparent',
  },
  size = '1em',
  active = false,
  ...rest
}: IconProps) => (
  <SvgWrapper style={style} size={size} active={active} {...rest}>
    {svg}
  </SvgWrapper>
);

export default Search;
